const toggle = document.querySelector('.dark-mode-toggle__button');
const toggleHandler = () => {
  const isPressed = toggle.getAttribute('aria-pressed') === 'true';
  toggle.setAttribute('aria-pressed', !isPressed);
  localStorage.setItem('dark-mode-active', !isPressed);
  document.documentElement.setAttribute('data-theme', !isPressed ? 'dark' : '');
};

if (localStorage.getItem('dark-mode-active') === 'true') {
  document.documentElement.setAttribute('data-theme', 'dark');
  document
    .querySelector('.dark-mode-toggle__button')
    ?.setAttribute('aria-pressed', 'true');
}
toggle?.addEventListener('click', toggleHandler);
